import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const GracePastDueAutomationEvent = BaseLoanEvent.extend({
  type: z.literal('gracePastDueAutomation'),
});
export type GracePastDueAutomationEvent = z.infer<typeof GracePastDueAutomationEvent>;
